export default "__VITE_ASSET__Dr9z1NfE__"